import styled from 'styled-components'
import { Box, Typography } from 'src/components'

export const OverHeader = styled(Box)`
    display: flex;
    justify-content: center;
    width: 100%;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        height: 500px;
    }
`

export const OverLimit = styled(Box)`
    display: flex;
    position: relative;
    flex-direction: row;
    align-items: center;
    width: 100%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1380px;
    }
`

export const HeaderDegraded = styled(Box)`
    width: 65%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    background: linear-gradient(
        88.55deg,
        #0e1920 65.53%,
        rgba(14, 25, 32, 0) 98.66%
    );
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: flex;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        display: flex;
        width: 55%;
    }
`

export const HeaderDegradedLeft = styled(Box)`
    width: 8%;
    height: 100%;
    position: absolute;
    right: -20px;
    display: none;
    z-index: 10;
    background: linear-gradient(
        269.55deg,
        #0e1920 65.53%,
        rgba(14, 25, 32, 0) 98.66%
    );
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: none;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        display: flex;
    }
`

export const HeaderImage = styled(Box)`
    width: 100%;
    height: 100%;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        margin-left: 170px;
    }
`

export const Image = styled.img`
    width: 100%;
    height: 100%;
    top: 0;
    object-fit: contain;
    display: inline-block;
    box-sizing: border-box;
    float: left;
`

export const TypographyTitle = styled(Typography)`
    font-family: Poppins, sans-serif;
    line-height: 21px;
    letter-spacing: 0;
    text-align: left;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 31px;
    }
`

export const TypographySubTitle = styled(Typography)`
    font-family: Poppins, sans-serif;
    line-height: 28px;
    letter-spacing: 0;
    width: 60%;
    text-align: left;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 38px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 88px;
    }
`

export const TypographySpan = styled(Typography)`
    font-family: Poppins, sans-serif;
    line-height: 28px;
    letter-spacing: 0;
    text-align: left;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 38px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 88px;
    }
`
